import React, { useState, useEffect } from 'react';

function MasterInvoice() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [listTransaksi, setListTransaksi] = useState([]);
  const [no_transaksi, setNoTransaksi] = useState('');
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  const numericKeys = [
    'TAGIHAN_KUBIK',
    'MIN_KUBIK',
    'TAGIHAN_KG',
    'MIN_KG',
    'TAGIHAN_KARTON',
    'MIN_KARTON',
    'TAGIHAN_BORONGAN',
    'MIN_BORONGAN',
    'BORONGAN_PER_KG',   
    'BORONGAN_PER_KG_ALL',      
  ];

  const columns = [
    'KOTA_ASAL',
    'KOTA_TUJUAN',
    'SUBCITY',
    'JNS_KENDARAAN',
    'JNS_MUATAN',
    'TAGIHAN_KUBIK',
    'MIN_KUBIK',
    'TAGIHAN_KG',
    'MIN_KG',
    'TAGIHAN_KARTON',
    'MIN_KARTON',
    'SUB_REGION',
    'TAGIHAN_BORONGAN',
    'MIN_BORONGAN',
    'BORONGAN_PER_KG',
    'BORONGAN_PER_KG_ALL',
    'NAMAREKANAN',
  ];

const columnLabels = {
  KOTA_ASAL: 'Asal',
  KOTA_TUJUAN: 'Tujuan',
  SUBCITY: 'Subcity',
  JNS_KENDARAAN: 'Jns Kend',
  JNS_MUATAN: 'Jns Muatan',
  TAGIHAN_KUBIK: 'Tagihan Kubik',
  MIN_KUBIK: 'Min Kubik',
  TAGIHAN_KG: 'Tagihan Kg',
  MIN_KG: 'Min Kg',
  TAGIHAN_KARTON: 'Tagihan Karton',
  MIN_KARTON: 'Min Karton',
  SUB_REGION: 'Sub Region',
  TAGIHAN_BORONGAN: 'Tagihan Borongan',
  MIN_BORONGAN: 'Min Borongan',
  BORONGAN_PER_KG: 'Borongan Per Kg',
  BORONGAN_PER_KG_ALL: 'Borongan Per Kg All',
  NAMAREKANAN: 'Rekanan',
};


  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const fetchPilihanTransaksi = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/master_invoice.php?caller=pilih_mi&schema=${schema}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setListTransaksi(data);
        if (data.length > 0) {
          setNoTransaksi(data[0].NO_TRANSAKSI);  
        }
      }
    } catch (error) {
      alert('Gagal memuat pilihan transaksi');
    }
  };


  const fetchLapPasangData = async () => {
    if (!no_transaksi) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/master_invoice.php?caller=isi_mi&schema=${schema}&no_transaksi=${no_transaksi}`;
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Data tidak valid');
      }
    } catch (error) {
      alert('Gagal memuat data');
    }
  };

  useEffect(() => {
    fetchPilihanTransaksi();
  }, []);


  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <h2 style={{ color: '#9B459C' }}>Master Invoice</h2>
      <div style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '300px' }}>
        <select
          value={no_transaksi}
          onChange={(e) => setNoTransaksi(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {listTransaksi.map((item, idx) => (
            <option key={idx} value={item.NO_TRANSAKSI}>
             {item.NAMAREKANAN}
            </option>
          ))}
        </select>


        <button onClick={fetchLapPasangData} style={{ marginLeft: '10px', padding: '5px 10px' }}>
          Refresh
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    backgroundColor: '#f2f2f2',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                   {columnLabels[col] || col} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`} style={{ border: '1px solid #ccc', padding: '4px' }}>
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{
                      width: '90%',
                      padding: '4px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                    }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td
                      key={key}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        textAlign: numericKeys.includes(key) ? 'right' : 'left',
                      }}
                    >
                      {numericKeys.includes(key) ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '10px' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MasterInvoice;
